// import {BaseNodeClass} from '../../../@polygonjs/polygonjs/src/engine/nodes/_Base';
import {CoreType} from '../../../@polygonjs/polygonjs/src/core/Type';
import {
	ExampleOptions,
	exampleNameToId,
	ExamplePrefix,
	// ExampleRelatedNodeWithLabel,
	ExampleCategory,
	ExampleCategoryWithLabel,
	DataCallbackOptions,
} from './Common';

export class Example {
	constructor(private _options: ExampleOptions) {}
	id() {
		return exampleNameToId(this.name());
	}
	name(): string {
		return this._options.name;
	}
	shortName() {
		const elements = this.name().split('/');
		return elements[elements.length - 1];
	}
	path(): string {
		// this returns the path that should resolve to the already saved thumbnail.
		//
		const nameElements = this.name().split('/');
		if (nameElements.length > 0) {
			return this.name();
		} else {
			return this.path()[0];
		}
	}
	paths(): string[] {
		const list: string[] = [];

		if (this._options.relatedNodeContextAndTypes) {
			for (let nodeContextAndType of this._options.relatedNodeContextAndTypes) {
				// const type = (nodeContextAndType).type;
				// if (type != null) {
				const path: string[] = [
					ExamplePrefix.BY_NODE,
					nodeContextAndType.context,
					nodeContextAndType.type,
					this.shortName(),
				];
				list.push(path.join('/'));
				// } else {
				// 	const labelled = nodeClassOrLabelled as ExampleRelatedNodeWithLabel;
				// 	const label = labelled.label;
				// 	const nodeClass = labelled.node;
				// 	const path: string[] = [ExamplePrefix.BY_NODE, nodeClass.context(), nodeClass.type(), label];
				// 	list.push(path.join('/'));
				// }
			}
		}
		if (this._options.categories) {
			for (let categoryOrWithLabel of this._options.categories) {
				if (CoreType.isString(categoryOrWithLabel)) {
					const category = categoryOrWithLabel as ExampleCategory;
					const path: string[] = [ExamplePrefix.BY_CATEGORY, category, this.shortName()];
					list.push(path.join('/'));
				} else {
					const categoryWithlabel = categoryOrWithLabel as ExampleCategoryWithLabel;
					const path: string[] = [
						ExamplePrefix.BY_CATEGORY,
						categoryWithlabel.category,
						categoryWithlabel.label,
					];
					list.push(path.join('/'));
				}
			}
		}

		return list;
	}
	label() {
		return this._options.label || this.shortName();
	}
	async data(options: DataCallbackOptions) {
		const {createData} = await this._options.createData();
		return createData(options);
	}
	relatedNodeContextAndTypes() {
		return this._options?.relatedNodeContextAndTypes;
		// const list = this._options?.relatedNodes;
		// return list?.map((nodeClassOrLabelled) => {
		// 	const type = (nodeClassOrLabelled as typeof BaseNodeClass).type;
		// 	if (type != null) {
		// 		return nodeClassOrLabelled as typeof BaseNodeClass;
		// 	} else {
		// 		return (nodeClassOrLabelled as ExampleRelatedNodeWithLabel).node;
		// 	}
		// });
	}
	categories(): ExampleCategory[] | undefined {
		return this._options?.categories?.map((categoryOrWithLabel) => {
			if (CoreType.isString(categoryOrWithLabel)) {
				return categoryOrWithLabel as ExampleCategory;
			} else {
				return (categoryOrWithLabel as ExampleCategoryWithLabel).category;
			}
		});
	}
	relatedExpressionTypes() {
		return this._options?.relatedExpressionTypes;
	}
	// label() {
	// 	return this._options?.label || this.name();
	// }
	// hasThumbnail() {
	// 	return this._options?.thumbnail || false;
	// }
}
